import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimPaginatorModule } from '@ngx-simple/simple-ui/paginator';
import { SimPseudoCheckboxModule } from '@ngx-simple/simple-ui/pseudo-checkbox';
import { SimSelectionModule } from '@ngx-simple/simple-ui/selection';
import { SimSortModule } from '@ngx-simple/simple-ui/sort';
import { SimSpinnerModule } from '@ngx-simple/simple-ui/spinner';
import {
  SimCellDefDirective,
  SimCellDirective,
  SimColumnDefDirective,
  SimFooterCellDefDirective,
  SimFooterCellDirective,
  SimHeaderCellDefDirective,
  SimHeaderCellDirective
} from './cell';
import { SimCheckboxColumnComponent } from './checkbox-column.component';
import {
  SimCdkCellOutletDirective,
  SimFooterRowComponent,
  SimFooterRowDefDirective,
  SimHeaderRowComponent,
  SimHeaderRowDefDirective,
  SimRowComponent,
  SimRowDefDirective
} from './row';
import { SimRowSelectionDirective } from './row-selection';
import { SimSelectionColumnComponent } from './selection-column.component';
import { SimTableDataComponent } from './table-data.component';
import { SimTableComponent } from './table.component';
import {
  SimFooterRowOutletDirective,
  SimHeaderRowOutletDirective,
  SimRowOutletDirective,
  SimTableActionsDirective,
  SimTableFooterDirective,
  SimTableHeaderDirective
} from './table.directive';
import { SimTextColumnComponent } from './text-column.component';

@NgModule({
  declarations: [
    SimTableComponent,
    SimRowOutletDirective,
    SimTableActionsDirective,
    SimColumnDefDirective,
    SimRowComponent,
    SimCdkCellOutletDirective,
    SimRowDefDirective,
    SimHeaderCellDirective,
    SimCellDirective,
    SimFooterCellDirective,
    SimCellDefDirective,
    SimHeaderCellDefDirective,
    SimFooterCellDefDirective,
    SimHeaderRowDefDirective,
    SimHeaderRowOutletDirective,
    SimHeaderRowComponent,
    SimFooterRowDefDirective,
    SimFooterRowComponent,
    SimFooterRowOutletDirective,
    SimTableDataComponent,
    SimTextColumnComponent,
    SimCheckboxColumnComponent,
    SimTableHeaderDirective,
    SimTableFooterDirective,
    SimSelectionColumnComponent,
    SimRowSelectionDirective
  ],
  imports: [CommonModule, SimSpinnerModule, SimPaginatorModule, SimSortModule, SimPseudoCheckboxModule, SimSelectionModule],
  exports: [
    SimSortModule,
    SimSelectionModule,
    SimPaginatorModule,
    SimSpinnerModule,
    SimTableComponent,
    SimTableActionsDirective,
    SimColumnDefDirective,
    SimRowComponent,
    SimRowDefDirective,
    SimHeaderCellDirective,
    SimCellDirective,
    SimFooterCellDirective,
    SimCellDefDirective,
    SimHeaderCellDefDirective,
    SimFooterCellDefDirective,
    SimHeaderRowDefDirective,
    SimHeaderRowComponent,
    SimFooterRowDefDirective,
    SimFooterRowComponent,
    SimTableDataComponent,
    SimTextColumnComponent,
    SimCheckboxColumnComponent,
    SimTableHeaderDirective,
    SimTableFooterDirective,
    SimSelectionColumnComponent,
    SimRowSelectionDirective
  ]
})
export class SimTableModule {}
